// 24px
import { ReactComponent as NH24Icon } from '../../assets/logo/banks/NH농협-24.svg'
import { ReactComponent as KB24Icon } from '../../assets/logo/banks/KB국민-24.svg'
import { ReactComponent as Shinhan24Icon } from '../../assets/logo/banks/신한-24.svg'
import { ReactComponent as Keb24Icon } from '../../assets/logo/banks/하나-24.svg'
import { ReactComponent as WO24Icon } from '../../assets/logo/banks/우리-24.svg'
import { ReactComponent as IBK24Icon } from '../../assets/logo/banks/IBK기업-24.svg'
import { ReactComponent as KDB24Icon } from '../../assets/logo/banks/KDB산업-24.svg'
import { ReactComponent as SC24Icon } from '../../assets/logo/banks/SC제일-24.svg'
import { ReactComponent as BS24Icon } from '../../assets/logo/banks/부산은행-24.svg'
import { ReactComponent as DG24Icon } from '../../assets/logo/banks/대구-24.svg'
import { ReactComponent as SH24Icon } from '../../assets/logo/banks/수협-24.svg'
import { ReactComponent as KN24Icon } from '../../assets/logo/banks/경남은행-24.svg'
import { ReactComponent as KJ24Icon } from '../../assets/logo/banks/광주-24.svg'
import { ReactComponent as JB24Icon } from '../../assets/logo/banks/전북-24.svg'
import { ReactComponent as Kakao24Icon } from '../../assets/logo/banks/카카오뱅크-24.svg'
import { ReactComponent as Toss24Icon } from '../../assets/logo/banks/토스뱅크-24.svg'
import { ReactComponent as K24Icon } from '../../assets/logo/banks/Kbank-24.svg'
import { ReactComponent as JJ24Icon } from '../../assets/logo/banks/제주-24.svg'
import { ReactComponent as Epost24Icon } from '../../assets/logo/banks/우체국-24.svg'
import { ReactComponent as CT24Icon } from '../../assets/logo/banks/씨티-24.svg'
import { ReactComponent as NACUFOK24Icon } from '../../assets/logo/banks/신협-24.svg'
import { ReactComponent as Blank24Icon } from '../../assets/logo/banks/blank-24.svg'

// 30px
import { ReactComponent as NH30Icon } from '../../assets/logo/banks/NH농협-30.svg'
import { ReactComponent as KB30Icon } from '../../assets/logo/banks/KB국민-30.svg'
import { ReactComponent as Shinhan30Icon } from '../../assets/logo/banks/신한-30.svg'
import { ReactComponent as Keb30Icon } from '../../assets/logo/banks/하나-30.svg'
import { ReactComponent as WO30Icon } from '../../assets/logo/banks/우리-30.svg'
import { ReactComponent as IBK30Icon } from '../../assets/logo/banks/IBK기업-30.svg'
import { ReactComponent as KDB30Icon } from '../../assets/logo/banks/KDB산업-30.svg'
import { ReactComponent as SC30Icon } from '../../assets/logo/banks/SC제일-30.svg'
import { ReactComponent as BS30Icon } from '../../assets/logo/banks/부산은행-30.svg'
import { ReactComponent as DG30Icon } from '../../assets/logo/banks/대구-30.svg'
import { ReactComponent as SH30Icon } from '../../assets/logo/banks/수협-30.svg'
import { ReactComponent as KN30Icon } from '../../assets/logo/banks/경남은행-30.svg'
import { ReactComponent as KJ30Icon } from '../../assets/logo/banks/광주-30.svg'
import { ReactComponent as JB30Icon } from '../../assets/logo/banks/전북-30.svg'
import { ReactComponent as Kakao30Icon } from '../../assets/logo/banks/카카오뱅크-30.svg'
import { ReactComponent as Toss30Icon } from '../../assets/logo/banks/토스뱅크-30.svg'
import { ReactComponent as K30Icon } from '../../assets/logo/banks/Kbank-30.svg'
import { ReactComponent as JJ30Icon } from '../../assets/logo/banks/제주-30.svg'
import { ReactComponent as Epost30Icon } from '../../assets/logo/banks/우체국-30.svg'
import { ReactComponent as CT30Icon } from '../../assets/logo/banks/씨티-30.svg'
import { ReactComponent as NACUFOK30Icon } from '../../assets/logo/banks/신협-30.svg'
import { ReactComponent as Blank30Icon } from '../../assets/logo/banks/blank-30.svg'

// 46px
import { ReactComponent as NH46Icon } from '../../assets/logo/banks/NH농협-46.svg'
import { ReactComponent as KB46Icon } from '../../assets/logo/banks/KB국민-46.svg'
import { ReactComponent as Shinhan46Icon } from '../../assets/logo/banks/신한-46.svg'
import { ReactComponent as Keb46Icon } from '../../assets/logo/banks/하나-46.svg'
import { ReactComponent as WO46Icon } from '../../assets/logo/banks/우리-46.svg'
import { ReactComponent as IBK46Icon } from '../../assets/logo/banks/IBK기업-46.svg'
import { ReactComponent as KDB46Icon } from '../../assets/logo/banks/KDB산업-46.svg'
import { ReactComponent as SC46Icon } from '../../assets/logo/banks/SC제일-46.svg'
import { ReactComponent as BS46Icon } from '../../assets/logo/banks/부산은행-46.svg'
import { ReactComponent as DG46Icon } from '../../assets/logo/banks/대구-46.svg'
import { ReactComponent as SH46Icon } from '../../assets/logo/banks/수협-46.svg'
import { ReactComponent as KN46Icon } from '../../assets/logo/banks/경남은행-46.svg'
import { ReactComponent as KJ46Icon } from '../../assets/logo/banks/광주-46.svg'
import { ReactComponent as JB46Icon } from '../../assets/logo/banks/전북-46.svg'
import { ReactComponent as Kakao46Icon } from '../../assets/logo/banks/카카오뱅크-46.svg'
import { ReactComponent as Toss46Icon } from '../../assets/logo/banks/토스뱅크-46.svg'
import { ReactComponent as K46Icon } from '../../assets/logo/banks/Kbank-46.svg'
import { ReactComponent as JJ46Icon } from '../../assets/logo/banks/제주-46.svg'
import { ReactComponent as Epost46Icon } from '../../assets/logo/banks/우체국-46.svg'
import { ReactComponent as CT46Icon } from '../../assets/logo/banks/씨티-46.svg'
import { ReactComponent as NACUFOK46Icon } from '../../assets/logo/banks/신협-46.svg'
import { ReactComponent as Blank46Icon } from '../../assets/logo/banks/blank-46.svg'

type BankName =
  | 'NH농협은행'
  | 'KB국민은행'
  | '신한은행'
  | 'KEB하나은행'
  | '우리은행'
  | 'IBK기업은행'
  | 'KDB산업은행'
  | 'SC제일은행'
  | '부산은행'
  | 'DGB대구은행'
  | 'SH수협은행'
  | 'BNK경남은행'
  | '광주은행'
  | '전북은행'
  | '카카오뱅크'
  | '토스뱅크'
  | '케이뱅크'
  | '제주은행'
  | '우체국'
  | '한국씨티은행'
  | '신협은행'

interface BankIconProps {
  size: 24 | 30 | 46
  name: BankName | undefined
}

// 24px
const getIcon24 = (name: BankName | undefined) => {
  switch (name) {
    case 'NH농협은행':
      return <NH24Icon />
    case 'KB국민은행':
      return <KB24Icon />
    case '신한은행':
      return <Shinhan24Icon />
    case 'KEB하나은행':
      return <Keb24Icon />
    case '우리은행':
      return <WO24Icon />
    case 'IBK기업은행':
      return <IBK24Icon />
    case 'KDB산업은행':
      return <KDB24Icon />
    case 'SC제일은행':
      return <SC24Icon />
    case '부산은행':
      return <BS24Icon />
    case 'DGB대구은행':
      return <DG24Icon />
    case 'SH수협은행':
      return <SH24Icon />
    case 'BNK경남은행':
      return <KN24Icon />
    case '광주은행':
      return <KJ24Icon />
    case '전북은행':
      return <JB24Icon />
    case '카카오뱅크':
      return <Kakao24Icon />
    case '토스뱅크':
      return <Toss24Icon />
    case '케이뱅크':
      return <K24Icon />
    case '제주은행':
      return <JJ24Icon />
    case '우체국':
      return <Epost24Icon />
    case '한국씨티은행':
      return <CT24Icon />
    case '신협은행':
      return <NACUFOK24Icon />
    default:
      return <Blank24Icon />
  }
}

// 30px
const getIcon30 = (name: BankName | undefined) => {
  switch (name) {
    case 'NH농협은행':
      return <NH30Icon />
    case 'KB국민은행':
      return <KB30Icon />
    case '신한은행':
      return <Shinhan30Icon />
    case 'KEB하나은행':
      return <Keb30Icon />
    case '우리은행':
      return <WO30Icon />
    case 'IBK기업은행':
      return <IBK30Icon />
    case 'KDB산업은행':
      return <KDB30Icon />
    case 'SC제일은행':
      return <SC30Icon />
    case '부산은행':
      return <BS30Icon />
    case 'DGB대구은행':
      return <DG30Icon />
    case 'SH수협은행':
      return <SH30Icon />
    case 'BNK경남은행':
      return <KN30Icon />
    case '광주은행':
      return <KJ30Icon />
    case '전북은행':
      return <JB30Icon />
    case '카카오뱅크':
      return <Kakao30Icon />
    case '토스뱅크':
      return <Toss30Icon />
    case '케이뱅크':
      return <K30Icon />
    case '제주은행':
      return <JJ30Icon />
    case '우체국':
      return <Epost30Icon />
    case '한국씨티은행':
      return <CT30Icon />
    case '신협은행':
      return <NACUFOK30Icon />
    default:
      return <Blank30Icon />
  }
}

// 46px
const getIcon46 = (name: BankName | undefined) => {
  switch (name) {
    case 'NH농협은행':
      return <NH46Icon />
    case 'KB국민은행':
      return <KB46Icon />
    case '신한은행':
      return <Shinhan46Icon />
    case 'KEB하나은행':
      return <Keb46Icon />
    case '우리은행':
      return <WO46Icon />
    case 'IBK기업은행':
      return <IBK46Icon />
    case 'KDB산업은행':
      return <KDB46Icon />
    case 'SC제일은행':
      return <SC46Icon />
    case '부산은행':
      return <BS46Icon />
    case 'DGB대구은행':
      return <DG46Icon />
    case 'SH수협은행':
      return <SH46Icon />
    case 'BNK경남은행':
      return <KN46Icon />
    case '광주은행':
      return <KJ46Icon />
    case '전북은행':
      return <JB46Icon />
    case '카카오뱅크':
      return <Kakao46Icon />
    case '토스뱅크':
      return <Toss46Icon />
    case '케이뱅크':
      return <K46Icon />
    case '제주은행':
      return <JJ46Icon />
    case '우체국':
      return <Epost46Icon />
    case '한국씨티은행':
      return <CT46Icon />
    case '신협은행':
      return <NACUFOK46Icon />
    default:
      return <Blank46Icon />
  }
}

export function BankIcon({ size, name }: BankIconProps) {
  switch (size) {
    case 24:
      return <>{getIcon24(name)}</>
    case 30:
      return <>{getIcon30(name)}</>
    case 46:
      return <>{getIcon46(name)}</>
  }
}

export type { BankName }
